import type { ColumnConfig } from '@/shared/ui/DataTable/DataTable';
import type { ProblemAddressResponse } from '@/core/generated/api';
import { formatDateTime } from '@/core/format';

/** Колонки проверки координат домов */
export const PROBLEM_ADDRESS_COLUMNS: ColumnConfig<ProblemAddressResponse>[] = [
    {
        field: 'city',
        header: 'Город',
    },
    {
        field: 'street',
        header: 'Улица',
    },
    {
        field: 'houseNumber',
        header: 'Дом',
    },
    {
        field: 'qcGeo.name',
        header: 'Исходная точность',
        body: (point: ProblemAddressResponse) => point.qcGeo?.name ?? 'Точность неизвестна',
    },
    {
        field: 'verifiedAt',
        dataType: 'date',
        header: 'Проверка',
        body: (point: ProblemAddressResponse) => point.verifiedAt
            ? formatDateTime(point.verifiedAt)
            : 'Требует проверки',
    },
];

/** Варианты качества координат дома */
export const COORDINATE_QUALITY_OPTIONS = [
    {
        value: '',
        label: 'Любая точность',
    },
    {
        value: '1',
        label: 'Соседний дом',
    },
    {
        value: '2',
        label: 'Улица',
    },
    {
        value: '3',
        label: 'Населённый пункт',
    },
    {
        value: '4',
        label: 'Город',
    },
    {
        value: '5',
        label: 'Координаты не определены',
    },
];
